import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import _ from 'lodash'

@Injectable({
    providedIn:'root'
})
export class RaffleDrawService{

    constructor(
        private http:HttpClient,
        private cookieService: CookieService
    )
    {}

    saveWinners(campaignId,basketRaffleWinners,raffleWinner){
        const token = this.cookieService.get('accessToken');
        const p = {
          "campaignId": campaignId,
          "basketRaffleWinners":basketRaffleWinners,
          "raffleWinner": raffleWinner,
        }
        const queryParams = [
            `access_token=${token}`,
            `p=${encodeURIComponent(JSON.stringify(p))}`
        ];
        return this.http.post(' /api/ticket/raffle/winner/save', _.join(queryParams, "&"), {
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    removeWinner(campaignId, winnerUserId){
        const token = this.cookieService.get('accessToken');
        const p = {
          "campaignId": campaignId,
          "raffleWinner":winnerUserId,
        }
        const queryParams = [
            `access_token=${token}`,
            `p=${encodeURIComponent(JSON.stringify(p))}`
        ];
        return this.http.post('/api/ticket/raffle/winner/remove', _.join(queryParams, "&"), {
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }
}